import * as React from 'react';
import { Monitor } from 'lucide-react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

interface IDeviceStatusCardProps {
  totalDevices: number;
  onlineDevices: number;
  offlineDevices: number;
  onlinePercentage: number;
}

const DeviceStatusCard = ({
  totalDevices,
  onlineDevices,
  offlineDevices,
  onlinePercentage,
}: IDeviceStatusCardProps) => {
  const formattedOnlinePercentage = `${onlinePercentage}%`;

  return (
    <div className="analytics-card">
      <div className="card-title">
        <Monitor size={20} strokeWidth={1.5} />
        <h2>Device Status</h2>
      </div>

      <div className="device-status-chart">
        <div className="circular-progress-wrapper">
          <CircularProgressbar
            value={onlinePercentage}
            styles={buildStyles({
              pathColor: 'var(--fuji-severity-low)',
              trailColor: 'var(--fuji-graph-trail-color)',
            })}
          />

          <div className="circular-progress-center-text">
            <span className="percentage-value">{formattedOnlinePercentage}</span>
            <span className="percentage-label">Online</span>
          </div>
        </div>

        <div className="device-status-legend">
          <div className="legend-item">
            <span className="legend-dot online"></span>
            <div className="legend-details">
              <span className="legend-label">Online</span>
              <span className="legend-value">{onlineDevices.toLocaleString()}</span>
            </div>
          </div>

          <div className="legend-item">
            <span className="legend-dot offline"></span>
            <div className="legend-details">
              <span className="legend-label">Offline</span>
              <span className="legend-value">{offlineDevices.toLocaleString()}</span>
            </div>
          </div>

          <div className="legend-item total">
            <div className="legend-details">
              <span className="legend-label">Total</span>
              <span className="legend-value">{totalDevices.toLocaleString()}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeviceStatusCard;